import {
    deleteAnimation,
    initFirebase,
    listenSessionsFromGroup,
    listenToAnimations,
    pushAnimation
} from "../domain/domain";
import {
    anonymousSignin,
    getUrlParameter
} from "../domain/utils";
import Vue from "vue";
import JSZip from "jszip";
import saveAs from "file-saver";
import { GifReader, GifWriter } from "omggif";


Vue.component("animation", {
    props: ["animation"],
    data: function () {
        return {}
    },
    template: `
        <img width="130" height="130" v-bind:src="animation.original" class="animation-container" v-bind:class="{ selected: animation.selected }" v-on:click="animation.selected = !animation.selected">
        </img>`,
    created: function () {},
    beforeDestroy: function () {}
});


export function viewSessionPage() {
    initFirebase();

    var sessionId = getUrlParameter("session");
    var sessionGroupId = getUrlParameter("session_group");

    let app = new Vue({
        el: "#app",
        data: {
            session_name: "",
            session_description: "",
            downloadScale: "10",
            downloadBackgroundTransparent: true,
            animations: < {
                primary_key: string,
                selected: boolean,
                original: string
            } [] > < unknown > [],
            sessions_in_group: < {
                session_id: string;
                session_name: any;
            } [] > []
        },


        methods: {
            download_string: function () {
                return JSON.stringify(this.animations.filter(function (x) {
                    return x.selected
                }).map(function (x) {
                    return x.original
                }));
            },

            dataURItoArray: function (dataURI: string) {
                var byteString = atob(dataURI.split(',')[1]);
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);

                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                return ia;
            },

            deleteGifs: function () {
                var images = this.animations.filter(function (x) {
                    return x.selected
                });
                var ok = confirm("This will permanently delete " + images.length + " images and can't be undone. Are you sure?");

                if (ok) {
                    for (var i = 0; i < images.length; i++) {
                        deleteAnimation(sessionId!, images[i].primary_key);
                    }
                }
            },

            downloadAnimations: function () {
                this.downloadAnimationsAction("original", false);
            },

            downloadAnimationsCustom: function () {
                this.downloadAnimationsAction(this.downloadScale, this.downloadBackgroundTransparent);
            },

            downloadAnimationsAction(scale: string, make_transparent: boolean): void {
                var zip = new JSZip();
                var buf: Uint8Array = < Uint8Array > < unknown > [];

                for (var anim = 0; anim < this.animations.length; anim++) {
                    buf = this.dataURItoArray(this.animations[anim].original);
                    if (scale != "original" || make_transparent) {
                        buf = this.processGifForDownload(buf, scale, make_transparent);
                    }
                    zip.file(anim + ".gif", buf);
                }

                var sn = this.session_name;
                zip.generateAsync({
                    type: "blob"
                }).then(function (content) {
                    saveAs(content, sn + ".zip");
                });
            },

            processGifForDownload(buffer: Uint8Array, scale: string, make_transparent: boolean): Uint8Array {
                let gr = new GifReader(<Buffer> <unknown> buffer);

                // Get the palette
                let frameInfo = gr.frameInfo(0);
                let paletteSize = frameInfo.palette_size!;
                let paletteOffset = frameInfo.palette_offset!;
                let palette = [];
                let colorToIndex : {[idx: number]: number}= {};

                for (let palette_index = 0; palette_index < paletteSize; palette_index++) {
                    var r = buffer[paletteOffset + palette_index * 3];
                    var g = buffer[paletteOffset + palette_index * 3 + 1];
                    var b = buffer[paletteOffset + palette_index * 3 + 2];
                    let color = (r * 256 + g) * 256 + b;
                    palette.push(color);
                    if (colorToIndex[color] === undefined) { colorToIndex[color] = palette_index; }
                }

                if (paletteSize == 2 && make_transparent) { // Make the always white when it's monocrome over transparent
                    palette[1] = 0xFFFFFF;
                }

                let frameCount = gr.numFrames();
                let width = gr.width;
                let height = gr.height;
                let scaleNumber = scale == "original" ? 1 : parseInt(scale);

                var outbuf = <Buffer> <unknown> [];
                
                var gf = new GifWriter(outbuf, width * scaleNumber, height * scaleNumber, {
                    palette: palette,
                    loop: 0
                });
                
                for (let j = 0; j < frameCount; j++) {
                    let idx = 0;
                    let pixels = new Uint8Array(gr.width * gr.height * 4);
                    let outpixels = new Uint8Array(width * height * scaleNumber * scaleNumber);
                    gr.decodeAndBlitFrameRGBA(j, pixels);

                    for(let y = 0; y < height; y++) {
                        for (let lineRepeat = 0; lineRepeat < scaleNumber; lineRepeat++) {    
                            for(let x = 0; x < height; x++) {
                                var r = pixels[(y * width + x) * 4];
                                var g = pixels[(y * width + x) * 4 + 1];
                                var b = pixels[(y * width + x) * 4 + 2];
                                let color = colorToIndex[(r * 256 + g) * 256 + b] || 0;
                                for (let colRepeat = 0; colRepeat < scaleNumber; colRepeat++) {
                                    outpixels[idx] = color;
                                    idx++;
                                }                                        
                            }
                        }
                    }

                    gf.addFrame(0, 0, width * scaleNumber, height * scaleNumber,
                        <number[]> <unknown> outpixels, {
                            delay: 30,
                            transparent: make_transparent ? 0 : undefined,
                            disposal: 2
                        });

                }

                outbuf = outbuf.slice(0, gf.end());
                return outbuf;
            },

            select_all_images: function() {
                for(let animation of app.animations) {
                    animation.selected = true;
                }
            },

            copy_to_clipboard: function () {
                var copyText = < HTMLTextAreaElement > document.getElementById("images-text") !;

                copyText.select();
                copyText.setSelectionRange(0, 99999); /* For mobile devices */

                navigator.clipboard.writeText(copyText.value);
            },

            store_images_from_clipboard: function () {
                var copyText = < HTMLTextAreaElement > document.getElementById("paste_images_textarea");
                var text = copyText.value;
                try {
                    var anims: [string] = JSON.parse(text);
                    anims.forEach(v => {
                        if (!v.startsWith("data:image/gif;base64")) {
                            alert("Invalid image data");
                        }
                    });

                    if (confirm("Paste " + anims.length + " images into the session?")) {
                        anims.forEach((anim) => pushAnimation(sessionId!, anim));
                        copyText.value = ""
                    }
                } catch (e) {
                    alert("Invalid image data");
                }


            }
        }
    });
    var root : any; var auth: any; var session: any;

    auth != null && root.child('user_secrets').child(auth.uid).hasChild(
        root.child('session_groups').child(
            root.child('animations').child(session).child('session_group').val()
        ).child('session_group_secret').val()
    )

    anonymousSignin().then((_user) => {
        listenSessionsFromGroup(sessionGroupId!, (sessions) => {
            app.sessions_in_group = Object.entries(sessions).map((entry) => ({
                session_id: entry[0],
                session_name: entry[1].session_name
            }))
        }, (_error) => {});


        listenToAnimations(sessionId!, (data) => {
            app.session_name = data.session_name;
            app.session_description = data.session_description;
            app.animations = Object.entries(data.animations)
                .map((anim, idx) => ({
                    original: anim[1],
                    key: idx,
                    primary_key: anim[0],
                    selected: false
                }))
        }, (error) => {
            alert("Error loading images: " + error);
        });
    })
}